import React from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OrdersIcon from "../../images/OrdersIcon.png"
import AddIcon from "@mui/icons-material/Add";

const NoOrders = () => {
  const navigate = useNavigate();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box>
        <img src={OrdersIcon} alt="Orders Icon"></img>
      </Box>
      <Box sx={{ textAlign: "center", width: "100%" }}>
        <Typography variant="h5" sx={{ fontSize: 18 }}>You currently don't have any orders</Typography>
        <Button
          variant="contained"
          disableElevation
          startIcon={<AddIcon />}
          sx={{ color: "white", width: "100%", mt: 2 }}
          onClick={() => navigate("/dashboard/new-order")}
        >
          Create New Order
        </Button>
      </Box>
    </Stack>
  );
};

export default NoOrders;
